export const TiposVisitantesActionTypes = {
  API_RESPONSE_SUCCESS: '@@tipos-visitante/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@tipos-visitante/API_RESPONSE_ERROR',

  GET_TIPO: '@@tipos-visitante/GET_TIPO',

  LIST_TIPOS: '@@tipos-visitante/LIST_TIPOS',
  ADD_TIPO: '@@tipos-visitante/ADD_TIPO',
  UPDATE_TIPO: '@@tipos-visitante/UPDATE_TIPO',
  DELETE_TIPO: '@@medtipos-visitanteios/DELETE_TIPO',
  SET_FILTER: '@@tipos-visitante/SET_FILTER',

  RESET: '@@tipos-visitante/RESET'
}
